<app-vault-module-shell
  moduleLabel="Panel de administración"
  [accessDenied]="accessDenied()"
  [loadError]="loadError()"
  [loadErrorTitle]="loadErrorTitle()"
>
  <section class="admin-dashboard">
    <app-page-header
      title="Panel de administración"
      subtitle="Resumen y accesos de administración del espacio Vault."
      icon="LayoutDashboard"
    />

    @if (loading()) {
      <div class="admin-dashboard__skeleton" aria-busy="true">
        <lib-skeleton variant="rectangle" [height]="'48px'" />
      </div>
    } @else if (ok()) {
      <lib-empty
        icon="ShieldCheck"
        message="Módulo administrativo accesible"
        description="La API de administración respondió correctamente (tenants)."
      />
    }
  </section>
</app-vault-module-shell>
